import { AccountSummaryData } from "../../../AccountSummary.slice";
import { useAppSelector } from "../../../store/hooks";

type AutopayNextCycle = NonNullable<AccountSummaryData["autopay"]>["nextCycle"];

export const getAutopayNextCycle = (nextCycle?: AutopayNextCycle) => {
  const today = new Date();
  const todayMidnightUTC = new Date(
    Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate())
  );
  const runDate = nextCycle?.runDate;
  const debitAmount = nextCycle?.debitAmount ?? 0;
  const hasUpcomingDebit =
    !!runDate &&
    new Date(runDate).getTime() >= todayMidnightUTC.getTime() &&
    debitAmount > 0;

  return {
    hasUpcomingDebit,
    debitAmount,
    runDate,
  };
};

export const useAutopayNextCycle = (account?: AccountSummaryData) => {
  const { data, activeTenantAccountIndex } = useAppSelector(
    (state) => state.accountSummary
  );
  const autopay = (account ?? data?.[activeTenantAccountIndex])?.autopay;

  return getAutopayNextCycle(autopay?.nextCycle);
};
